import { useMutation, useQuery } from '@apollo/client/react';
import React, { useContext } from 'react';

import { CartOpenContext } from "../../context/CartOpenContext";
import { CartContext, formatCustomAttributes } from "../../context/CheckoutContext";

import {
    shopProducts,
} from '../../graphql/shopQuery';

import {
    cartLinesAdd,
    checkoutCompleteErrorEffect,
    useCheckoutEffect,
} from '../../graphql/checkoutQuery';

function Products(props, ...children){

  const [isCartOpen, setCartOpen] = useContext(CartOpenContext);
  const { cartState, createCartLoading, resetToNewCart } = useContext(CartContext);
  const [cart, setCart] = cartState;

  const [lineItemAddMutation,
  {
    data: lineItemAddData,
    loading: lineItemAddLoading,
    error: lineItemAddError
  }] = useMutation(cartLinesAdd);

  // never cache getting the shop products
  //const queryOptions = {fetchPolicy:"no-cache"};
  const queryOptions = {};

  const {
    loading:productsLoading,
    error:productsError,
    data:productsData,
    refetch:refetchProducts
  } = useQuery(shopProducts, queryOptions);

  useCheckoutEffect(lineItemAddData, 'cartLinesAdd', setCart, resetToNewCart);

  const addVariantToCart = (variantId, quantity, attrs) =>{
    // console.log("addVariantToCart", variantId, quantity, attrs, cart);
    const variables = {
      cartId: cart.id,
      lines: [
        {
          merchandiseId: variantId,
          quantity: parseInt(quantity, 10),
        }
      ]
    };

    if(attrs){
      variables.lines[0]['attributes'] = formatCustomAttributes( {...attrs, ...CHART_PARAMS} );
    }

    lineItemAddMutation({ variables }).then(res => {
      setCartOpen(true);
    });
  };

  // TODO: run this by product title instead
  const getProduct = ( gql_id ) => {
    if( !gql_id ){
      throw 'getProduct - Missing GQL ID';
    }
    /*
    // get the GQL ids of all the products
    console.log(productsData);
    productsData.products.edges.map(product => {
      console.log("TITLE",product.node.title);
      console.log("ID",product.node.id);
      console.log("ffffffffffffffffffffffffffffffffffffff");
    })
    */

    const product = productsData.products.edges.find(product => gql_id === product.node.id )

    if( !product ){
      console.log(`Wow, refetching! gql_id: ${gql_id}`, productsData)
      refetchProducts();
      // return a string to differentiate between a null value in the fetched product
      return 'refetching';
    }

    if( !product.node ){
      throw "Empty product - no node. Can't render this product: gql_id ${gql_id}"
    }

    return product.node;
  };

  if( productsError ) throw productsError;

  checkoutCompleteErrorEffect( lineItemAddError, resetToNewCart );

  if (createCartLoading || productsLoading) {
    return (<div className="row product-shim-loading-cont">
         <div className="shim-cont">
           <div className="shim-wrapper">
              <div className="shim-box shimmer-animate"></div>
              <div className="shim-box shimmer-animate"></div>
              <div className="shim-box shimmer-animate"></div>
           </div>
         </div>
      </div>);
  }

  // pass these cart props to every child of the product wrapper

  // TODO: move the loading UI out of this component to a different wrapper
  // pass the loading state down

  return props.children({
    addVariantToCart,
    cart,
    getProduct,
    lineItemAddLoading,
  });
}

export default Products;
